import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

export interface ChargePointsReasonsCellProps
  extends CellContext<
    GatewayChargePointInMaintenanceModel,
    GatewayChargePointInMaintenanceModel['reasons']
  > {}

export const ChargePointsReasonsCell = (
  props: ChargePointsReasonsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.XS} flexWrap="wrap">
      {getValue().map((reason) => (
        <Tag className="bg-surface-secondary" key={reason}>
          {t(
            `delmonicos-shared-sdk.enums-charge-point-maintenance-reason.${reason}`,
          )}
        </Tag>
      ))}
    </Stack>
  );
};
